/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import { X } from 'lucide-react';
import ResponsiveTable from '../../../components/Table/Responsivetable';

const ViewChapterModal = ({
  open,
  onClose,
  chapter,
  sourceName,
  getDifficultyBadgeClass,
  previewQuestionColumns,
  previewLoading = false,
}) => {
  console.log(previewQuestionColumns,"previewQuestionColumns");
  
  let questionsContent = (
    <ResponsiveTable
      columns={previewQuestionColumns}
      data={chapter?.questions || []}
      loading={previewLoading}
    />
  );

  if (previewLoading) {
    questionsContent = (
      <ResponsiveTable
        columns={previewQuestionColumns}
        data={[]}
        loading
      />
      
    );
  } else if ((chapter?.questions || []).length === 0) {
    questionsContent = (
      <div className="border border-dashed border-indigo-200 rounded-lg py-10 text-center text-sm text-gray-500 bg-white">
        No questions tagged to this chapter yet
      </div>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      BackdropProps={{
        sx: {
          backdropFilter: 'blur(3px)',
          backgroundColor: 'rgba(0,0,0,0.25)',
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <div className="relative bg-white rounded-lg shadow-xl w-full p-6">
          <div className="flex items-start justify-between mb-4 gap-3">
              <h2
              className="text-xl font-semibold text-gray-800 break-words line-clamp-1"
              title={`Preview Chapter: ${chapter?.module_name || ''}`}
            >
              Preview Chapter: {chapter?.module_name}
            </h2>
            <IconButton id="close-chapter-preview-btn" onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <X size={20} />
            </IconButton>
          </div>

          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-6 mb-6 bg-gray-50/60 rounded-lg px-4 py-3">
              <div>
                <label className="block text-sm text-gray-600 mb-1">Source</label>
                <p
                  className="text-base font-semibold text-gray-900 break-words line-clamp-2"
                  title={sourceName}
                >
                  {sourceName || 'New Source'}
                </p>
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">Difficulty</label>
                <span id="chapter-difficulty-badge" className={`inline-flex items-center px-3 py-1 rounded-md text-xs font-semibold uppercase ${getDifficultyBadgeClass(chapter?.complexity_level)}`}>
                  {chapter?.complexity_level || 'MEDIUM'}
                </span>
              </div>
            </div>

            <div className="mt-6">
              {/* <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Questions ({chapter?.questions?.length || 0})
              </h3> */}
              <div className="bg-gray-50 border border-gray-200 rounded-lg px-5 py-4 w-full">
                <p className="text-sm text-gray-500 mb-1">Total Questions</p>
                <p id="chapter-total-questions" className="text-2xl font-bold text-gray-900">
                  {chapter?.questionCount ?? chapter?.questions_list?.length ?? 0}
                </p>
              </div>
              {/* {questionsContent} */}
            </div>
          </div>

          <div className="mt-6 flex justify-end">
            <button
              id="chapter-preview-close-btn"
              onClick={onClose}
              className="px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800"
            >
              Close
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewChapterModal;